<template>
  <div>
    <!-- 支払日 -->
    <app-input-status
      label="支払日"
      color="yellow"
      :message="paymentDateError"
      :validationError="paymentDateError ? true : false"
      :success="paymentDate && !paymentDateError ? true : false"
    />
    <app-date-input
      placeholder="年/月/日"
      color="yellow"
      v-model="paymentDate"
      name="paymentDate"
    />

    <!-- 支払い金額 -->
    <app-input-status
      label="支払い金額"
      class="mt-3"
      color="yellow"
      :message="amountError"
      :validationError="amountError ? true : false"
      :success="amount && !amountError ? true : false"
    />
    <app-text-input
      class="mr-3 w-40"
      type="number"
      :block="false"
      color="yellow"
      rows="1"
      placeholder="0"
      v-model.number="amount"
      name="amount"
    />
    <span class="text-yellow text-lg font-bold">円</span>

    <!-- 予算項目 -->
    <app-input-status
      label="予算項目"
      class="mt-3"
      color="yellow"
      :message="contentIdListError"
      :validationError="contentIdListError ? true : false"
      :success="contentIdList && !contentIdListError ? true : false"
    />
    <app-pull-down-list
      color="yellow"
      placeholder="予算項目を選択ください"
      :items="items"
      v-model="contentIdList"
      name="contentIdList"
    />

    <!-- 内容詳細 -->
    <app-input-status
      label="内容詳細"
      class="mt-2"
      color="yellow"
      :message="remarksError"
      :validationError="remarksError ? true : false"
      :success="remarks && !remarksError ? true : false"
    />
    <app-text-input
      color="yellow"
      rows="1"
      placeholder="内容詳細を入力ください"
      style="width:664px"
      name="remarks"
      v-model="remarks"
    />
    <budget-preview v-show="false" :Date="paymentDate" />
  </div>
  <button
    id="budget-validate-default"
    style="display: none;"
    @click="budgetSubmit(true)"
  ></button>
</template>

<script>
import AppInputStatus from '@/components/ui/AppInputStatus'
import AppTextInput from '@/components/ui/AppTextInput'
import AppDateInput from '@/components/ui/AppDateInput'
import AppPullDownList from '@/components/ui/AppPullDownList'
import { useBudgetForm } from '@/services/useBudgetForm'
import BudgetPreview from '@/components/layout/budgets/BudgetPreview'

export default {
  name: 'BudgetForm',

  components: {
    AppInputStatus,
    AppTextInput,
    AppDateInput,
    BudgetPreview,
    AppPullDownList,
  },
  setup() {
    return {
      ...useBudgetForm(),
    }
  },
}
</script>
<style lang="scss" scoped></style>
